import { CommonModule as ACommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ActionCable } from './action-cable';
import { AutolinkPipe } from './autolink.pipe';
import { Base64 } from './base64';
import { Cookies } from './cookies';
import { DateAsUTCDirective } from './date-as-utc.directive';
import { DialogLinkDirective } from './dialog-link.directive';
import { FormHandler } from './form-handler';
import { FormComponent } from './form/form.component';
import { Head } from './head';
import { InspectorCLI } from './inspector-cli';
import { NetworkInformation } from './network-information';
import { OpenGraph } from './opengraph';
import { PageService } from './page-service';
import { Redirection } from './redirection';
import { RequestParams } from './request-params';
import { ResponsiveBackgroundImageDirective } from './responsive-background-image.directive';
import { ResponsiveBackgroundPipe } from './responsive-background-pipe';
import { SectionLinkComponent } from './section-link/section-link.component';
import { Shell } from './shell';
import { SoftwareKeyboard } from './software-keyboard';
import { SpinnerComponent } from './spinner/spinner.component';
import { StagingNoteComponent } from './staging-note/staging-note.component';
import { UserAgent } from './user-agent';
import { ViewportSize } from './viewport-size';

import { MaterialModule } from '../app/material.module';
import { AppConfig } from './app-config';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { DurationPipe } from './duration.pipe';
import { HlsVideoPlayerDirective } from './hls-video-player.directive';
import { LoggerService } from './logger.service';
import { MessageDialogComponent } from './message-dialog/message-dialog.component';
import { NoticeService } from './notice-service';
import { NoticeComponent } from './notice/notice.component';
import { TrustHtmlPipe } from './trust-html.pipe';
import { CopyBoxComponent } from './copy-box/copy-box.component';

const COMPONENTS = [
  SectionLinkComponent,
  FormComponent,
  SpinnerComponent,
  StagingNoteComponent,
  ResponsiveBackgroundPipe,
  ResponsiveBackgroundImageDirective,
  DialogLinkDirective,
  DateAsUTCDirective,
  AutolinkPipe,
  NoticeComponent,
  TrustHtmlPipe,
  DurationPipe,
  HlsVideoPlayerDirective,
  MessageDialogComponent,
  ConfirmationDialogComponent,
  CopyBoxComponent
];

@NgModule({
  imports: [
    FormsModule,
    RouterModule,
    ACommonModule,
    MaterialModule
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS
})
export class TYTCommonModule {
  static forRoot(): ModuleWithProviders<TYTCommonModule> {
    return {
      ngModule: TYTCommonModule,
      providers: [
        Shell,
        NetworkInformation,
        Cookies,
        Base64,
        UserAgent,
        FormHandler,
        SoftwareKeyboard,
        PageService,
        RequestParams,
        ActionCable,
        InspectorCLI,
        OpenGraph,
        Head,
        AppConfig,
        ViewportSize,
        Redirection,
        LoggerService,
        NoticeService
      ]
    };
  }
}
